import * as React from 'react';
import {LazyMotion} from './LazyMotion';

const loadFeatures = () => import('./features').then((mod) => mod.default);

type MotionProviderProps = {
  children: React.ReactNode;
  enabled?: boolean;
};

export function MotionProvider({
  children,
  enabled = false,
}: MotionProviderProps) {
  if (!enabled) {
    return <>{children}</>;
  }
  return (
    <LazyMotion strict={false} features={loadFeatures}>
      {children}
    </LazyMotion>
  );
}
